import { useMemo } from 'react';
import { Alert, Box } from '@mui/material';

import { RetailerNetworkTobaccoProgramMetricType } from '@occc/graphql';
import { MetricBarChart } from '@occc/ui-design-system';
import { DateTimeFormat, formatDateTime, parseDate } from '@occc-app/lib/date';
import { CircularProgress } from '@occc/ui-design-system';

import { useRetailerNetworkTobaccoProgramMetricTimeSeries } from '../../../hooks/use-retailer-network-tobacco-program-metric-time-series.hook';
import { errorMessage } from '../../../retailer-connect.copies';

const CHART_HEIGHT = 180;

type MetricTimeSeriesContainerProps = {
  metricType: RetailerNetworkTobaccoProgramMetricType;
  dateFrom: Date;
  dateTo: Date;
  retailerNetworkUuid: string;
};

export function MetricTimeSeriesContainer(props: MetricTimeSeriesContainerProps) {
  const { metricType, dateFrom, dateTo, retailerNetworkUuid } = props;

  const { data, loading } = useRetailerNetworkTobaccoProgramMetricTimeSeries(metricType, {
    dateFrom: formatDateTime(dateFrom, DateTimeFormat.DateDashed),
    dateTo: formatDateTime(dateTo, DateTimeFormat.DateDashed),
    retailerNetworkUuidEquals: retailerNetworkUuid,
  });

  const metrics = useMemo(() => {
    return data?.retailerNetworkTobaccoProgramMetricTimeSeries.map(({ date, value }) => ({
      date: parseDate(date),
      value,
    }));
  }, [data]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: CHART_HEIGHT,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (metrics) {
    return <MetricBarChart metrics={metrics} />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Alert severity='error'>{errorMessage}</Alert>
    </Box>
  );
}
